import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";
import { ZealClientError } from "../../../AbstractApiClient/ZealClientError";
import {
  TCreatePaymentRequestSchema,
  TCreatePaymentResponseSchema,
} from "./createPayment.schema";

export const createPayment = (axios: IAxiosInstance) => {
  return async (requestBody: TCreatePaymentRequestSchema) => {
    try {
      const { data } = await axios.noRetry.post<
        IApiResponse<TCreatePaymentResponseSchema>
      >(`/payments`, requestBody);

      return data;
    } catch (e) {
      throw new ZealClientError(e);
    }
  };
};
